import { compose, withProps } from 'recompose';

import withDeviceInfo from 'ggApp/shared/components/viewport/withDeviceInfo';

import Summary from './Summary';

const enhance = compose(
    withDeviceInfo,
    withProps(({ userDevice }) => ({
        isDesktopUser: userDevice !== 'mobile' && userDevice !== 'tablet',
    })),
);

export default enhance(Summary);
